import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {usePipelines} from '../hooks/usePipelines.ts';
import {usePipelinesFilter} from '../hooks/usePipelinesFilter.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {usePipelinesSelection} from '../hooks/usePipelinesSelection.ts';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {usePipelinesSearch} from "../hooks/usePipelinesSearch.ts";
import {usePipelinesTableColumns} from "../hooks/usePipelinesTableColumns.tsx";
import {rbacActions} from "../../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = usePipelinesFilter();

    const {
        visibleItems: records,
        loading,
        nextToken,
        fetchNextPage,
    } = usePipelines(filters);

    const {
        columns,
    } = usePipelinesTableColumns();

    const {
        keyword,
        handleFilterByKeyword,
    } = usePipelinesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = usePipelinesSelection();

    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeletePipeline)) {
        selectedRecords = records.filter(record => selection[record.id])
    }

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.id, true)
                    })
                }}
                fetching={loading}
                onScrollToBottom={() => fetchNextPage()}
                scrollViewportRef={scrollViewportRef}
            />

            <DataTableTokenPagination
                loadedCount={records.length}
                filterTerm={keyword}
                nextToken={nextToken}
                handleLoadMore={fetchNextPage}
            />
        </Stack>
    );
};
